module.exports = __webpack_public_path__ + "img/6.e97b803f.jpg";